export const mapStyles = {
    height: "100%",
    width: "100%"
}